import { Listbox, ListboxProps } from '@headlessui/react';
import React from 'react';
import { ForwardedRef } from 'react';

export type SelectProps<T = string> = {
  onChange?: (value: T) => void;
  ref?: ForwardedRef<HTMLElement>;
  value?: T;
} & Except<ListboxProps, 'onChange' | 'value'>;

const Select = <T = string,>({ ref, onChange, value, ...props }: SelectProps<T>) => (
  <Listbox
    as="div"
    onChange={onChange as () => void}
    ref={ref}
    value={value as string}
    {...props}
  />
);

export default Select;
